var render = function render(){var _vm=this,_c=_vm._self._c;return _c('create',{attrs:{"invoice_id":_vm.$route.params.invoice_id},on:{"cancel":function($event){return _vm.$emit('cancel')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }